import React from "react";

function MainWid() {
  return (
    <section className="contact-area  pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-10">
            <div
              className="contact-form-wrap"
              style={{
                backgroundImage: `url(${require("../../assets/img/images/contact_form_bg.jpg")})`,
              }}
            >
              <h2 className="title">Zeptejte se nás!</h2>
              <p>Pošlete nám zprávu a my se Vám obratem ozveme.</p>
              <form action="#" className="contact-form">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input id="firstName" type="text" placeholder="Jméno*" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        id="lastName"
                        type="text"
                        placeholder="Příjmení*"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input id="email" type="email" placeholder="Váš Email*" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        id="phone"
                        type="text"
                        placeholder="Vaše telefonní číslo*"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-grp">
                  <input id="subject" type="text" placeholder="Předmět" />
                </div>
                <div className="form-grp">
                  <textarea
                    id="message"
                    placeholder="Vaše zpráva ..."
                  ></textarea>
                </div>
                <button className="btn" type="submit">
                  Odeslat
                </button>
              </form>
            </div>
          </div>
          <div className="col-xl-6 col-lg-10">
            <div className="contact-info-wrap">
              <h2 className="title">Kontakt na nás</h2>
              <p>
                Sídlo: Marc spol. s r.o., Na poříčí 1041/12, Praha 1, PSČ: 110
                00
                <br />
                Provoz: Marc spol. s r.o., U Elektry 650/2, Praha 9 - Hloubětín,
                PSČ: 198 00
              </p>
              <p>
                <b>BÚ CZK:</b> 178602842/0300, ČSOB <br />
                <b>IBAN CZK:</b> CZ35 0300 0000 0001 7860 2842 <b>BIC:</b>{" "}
                CEKOCZPP <br />
                <br />
                <b>BÚ EUR:</b> 187178596/0300, ČSOB <br />
                <b>IBAN EUR:</b> CZ79 0300 0000 0001 8717 8596 <b>BIC:</b>{" "}
                CEKOCZPP
              </p>
              <p>
                Registrace v obchodním rejstříku Městského soudu v Praze, oddíl
                C, vložka 9138.
                <br />
                IČ: 45271780, DIČ: CZ45271780
              </p>
              <ul className="list-wrap">
                <li>
                  <div className="contact-info-item">
                    <div className="icon">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div className="content">
                      <a href="tel:0123456789">+(420) 266 610 930</a>
                      Fax: +420 266 610 927
                    </div>
                  </div>
                </li>
                <li>
                  <div className="contact-info-item">
                    <div className="icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="content">
                      <a href="mailto:info@marcsteel.cz">info@marcsteel.cz</a>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="contact-info-item">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="content">
                      <a
                        href="https://maps.app.goo.gl/FEuWPrEPW6vd6JUF6"
                        target="_blank"
                      >
                        <p>U Elektry 650, 198 00 Praha</p>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div id="contact-map">
              <iframe
                width="100%"
                height="600"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=U%20Elektry%20650%20198%2000%20Praha+(MARC%20spol%20s.r.o.)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainWid;
